import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AuthLayout from "./AuthLayout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Register() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    company: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    let data = new FormData();
    data.append("first_name", formData.firstName);
    data.append("last_name", formData.lastName);
    data.append("email", formData.email);
    data.append("phone_number", formData.mobile);
    data.append("company_name", formData.company);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}register`,
        data,
        {
          headers: {
            "api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );
      localStorage.setItem("registerSuccessMessage", response.data.message);
      navigate("/login");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { name: "email", label: "Work email", type: "email", autoComplete: "email", placeholder: "you@company.com" },
    { name: "mobile", label: "Mobile number", type: "tel", autoComplete: "tel", placeholder: "+1 555 123 4567" },
    { name: "company", label: "Company or organization", type: "text", autoComplete: "organization" },
  ];

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      <AuthLayout title="Create your free account" subtitle="We’ll email your login details so you can explore the latest budget data.">
        <form onSubmit={handleRegister} className="auth-form">
          <div className="row g-3 mb-3">
            <div className="col-sm-6">
              <label className="form-label" htmlFor="register-firstName">First name</label>
              <input id="register-firstName" type="text" className="form-control" name="firstName" value={formData.firstName} onChange={handleChange} autoComplete="given-name" required />
            </div>
            <div className="col-sm-6">
              <label className="form-label" htmlFor="register-lastName">Last name</label>
              <input id="register-lastName" type="text" className="form-control" name="lastName" value={formData.lastName} onChange={handleChange} autoComplete="family-name" required />
            </div>
          </div>
          {fields.map(({ label, ...input }) => (
            <div className="mb-3" key={input.name}>
              <label className="form-label" htmlFor={`register-${input.name}`}>{label}</label>
              <input id={`register-${input.name}`} className="form-control" value={formData[input.name]} onChange={handleChange} required {...input} />
            </div>
          ))}
          <button type="submit" className="btn auth-submit" disabled={loading}>
            {loading ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Creating account…</> : <>Create account <span aria-hidden="true">→</span></>}
          </button>
          <p className="auth-legal">By registering you agree to our <Link to="/privacy-policy">privacy policy</Link>.</p>
          <p className="auth-switch">
            Already have an account? <Link to="/login">Log in</Link>
          </p>
        </form>
      </AuthLayout>
    </>
  );
}
export default Register;
